import React from "react";
import styled from "styled-components";
import { continueData } from "@stores/bookdata";
import { useNavigate } from "react-router";
import { useAtomValue, useSetAtom } from "jotai";
import {
  soundPopState,
  wordPopState,
  activityPopState,
  gamePopState,
} from "@stores/popup";

const Wrap = styled.div`
  position: relative;
  width: 1000px;
  margin-bottom: 50px;
`;

const Box = styled.div`
  position: relative;
  width: 358px;
  height: 600px;
  border: 7px solid #fff;
  border-radius: 40px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  &:before {
    content: "";
    position: absolute;
    left: 12px;
    top: 12px;
    width: 95px;
    height: 95px;
    background: url(${require("@assets/img/continue_arrow.png")}) no-repeat;
  }
`;

const Text = styled.div`
  color: #fff;
  font-size: 70px;
`;

const BookCover = styled.div`
  width: 600px;
  height: 600px;
  border-radius: 40px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: url(${({ url }) => url}) no-repeat;
  background-size: cover;
  background-position: 50% 50%;
`;

const ObjectWrap = styled.div`
  position: absolute;
  left: 390px;
  top: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  .column {
    flex: 0 auto;
    &:first-child {
      margin-right: 40px;
    }
  }
`;

const Grade = styled.span`
  font-size: 40px;
  color: #ffba00;
  display: block;
`;
const Title = styled.span`
  font-size: 55px;
  color: #fff;
  display: block;
  margin-top: 10px;
  white-space: nowrap;
`;

const StartButton = styled.button`
  display: inline-block;
  width: 568px;
  height: 137px;
  margin-top: 35px;
  background: url(${require("@assets/img/start_button.png")});
`;

const IconButtonWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const IconButton = styled.button`
  display: inline-block;
  width: 276px;
  height: 130px;
  margin-top: 14px;
  &.disabled {
    //filter: grayscale(1);
    //pointer-events: none;
    display: none;
  }
  &.ty1 {
    background: url(${require("@assets/img/icon_button_song.png")});
  }
  &.ty2 {
    background: url(${require("@assets/img/icon_button_word.png")});
  }
  &.ty3 {
    background: url(${require("@assets/img/icon_button_activity.png")});
  }
  &.ty4 {
    background: url(${require("@assets/img/icon_button_game.png")});
  }
`;

const ContinueBox = ({ continuePage }) => {
  const data = useAtomValue(continueData);
  const setSoundAndReadData = useSetAtom(soundPopState);
  const setActivity = useSetAtom(activityPopState);
  const setGame = useSetAtom(gamePopState);
  const setWord = useSetAtom(wordPopState);
  const navigate = useNavigate();

  const onStartBook = () => {
    window.__continue_page = continuePage;
    navigate(`${data.categoryKey}/${data.key}`);
  };
  const onOpenSound = () => {
    setSoundAndReadData({
      open: true,
      cover: data.cover,
      category: data.category,
      title: data.title,
      grade: data.grade,
      url: data.song.url,
      songTitle: data.song.title,
      caption: data.song.caption,
    });
  };
  const onOpenWord = () => {
    if (data.word.length === 0) {
      setWord({
        open: true,
        mode: "word2",
        data: data.word || [],
        data2: data.idiom || [],
      });
    } else {
      setWord({
        open: true,
        mode: "word",
        data: data.word || [],
        data2: data.idiom || [],
      });
    }
  };
  const onOpenActivity = () => {
    setActivity({
      open: true,
      type: data.activity.type,
      questions: data.activity.questions,
    });
  };
  const onOpenGame = () => {
    setGame({
      open: true,
      data: data.game,
      categoryKey: data.categoryKey,
    });
  };

  return (
    data && (
      <Wrap id="continueBox">
        <Box>
          <Text>
            이어
            <br />
            보기
          </Text>
        </Box>

        <ObjectWrap>
          <div className="column">
            <BookCover url={data.cover} />
          </div>
          <div className="column">
            <Grade>{`${data.category} ${data.grade}`}</Grade>
            <Title>{data.title}</Title>

            <StartButton type="button" onClick={onStartBook} />
            <IconButtonWrap>
              <IconButton
                type="button"
                className={
                  data.song && data.song.url !== "" ? "ty1" : "ty1 disabled"
                }
                onClick={onOpenSound}
              />
              <IconButton
                type="button"
                className={
                  data.word.length > 0 || data.idiom.length > 0
                    ? "ty2"
                    : "ty2 disabled"
                }
                onClick={onOpenWord}
              />
              <IconButton
                type="button"
                className={
                  data.activity.questions.length > 0 ? "ty3" : "ty3 disabled"
                }
                onClick={onOpenActivity}
              />
              <IconButton
                className={
                  data.game && data.game.resources.length
                    ? "ty4"
                    : "ty4 disabled"
                }
                onClick={onOpenGame}
              />
            </IconButtonWrap>
          </div>
        </ObjectWrap>
      </Wrap>
    )
  );
};
export default ContinueBox;
